import request from "../request";

export const check = ({ email }) => {
  return request({
    url: "/user/check",
    data: {
      email
    },
    needOverlay: false
  });
};
